<template>
  <div>
    <el-date-picker
      v-model="value"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="timestamp"
      @change="changeTime"
      align="center"
      size="mini"
      :editable="false"
      v-if="styleType == 1"
    >
    </el-date-picker>
    <div class="time2 flexRowCenter" v-if="styleType == 2" @click.stop="toShow()">
      <template v-if="start && end">
        <img src="https://oss.yf-gz.cn/file/1739271885222_64ed954b0d3390668fb3a3c528519d68.png" alt="" class="prefix_img">
        <div style="color: #0A89FF">{{ date }}</div>
      </template>
      <template v-else>
        <img src="https://oss.yf-gz.cn/file/1739272241340_f8f5aa752d86230313ef5a7cad710baa.png" alt="" class="prefix_img">
        <div>选择时间</div>
      </template>
    </div>
		<!-- 日历弹窗 -->
		<van-calendar
			v-model="showCalendar"
			type="range"
			:color="'#0084ff'"
			@confirm="changeTime"
			allow-same-day
			:show-confirm="false"
			@select="onSelect"
      :default-date="currentDate"
      :formatter="formatter"
			:min-date="minDate"
      ref="calendarComponent"
      style="z-index: 9999;"
		>
			<!-- 添加清除按钮 -->
			<template #footer>
        <div class="calendar-footer">
          <van-button 
            block 
            type="default" 
            @click.stop="clearDate"
            round
          >清除</van-button>
          <!-- <van-button 
            block 
            type="primary" 
            color="#0084ff" 
            @click="onConfirm"
          >确定</van-button> -->
        </div>
      </template>
		</van-calendar>
  </div>
</template>

<script>
import Mission from "@/tool/classFactory/Mission.js";
import { getCurrentWeekStartTimeAndEndTime } from '@/tool/transform.js';

export default {
  props: {
    startTime: {
      type: Number,
    },
    endTime:  {
      type: Number,
    },
    //默认填充本周时间
    currentWeek: {
      type: Boolean,
      default: false
    },
    styleType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      value: [],
      start: '',
      end: '',
			showCalendar: false,
			date: '',
			currentDate: [new Date(), new Date()], // 存储当前选中的日期范围
			minDate: this.getThreeMonthsAgo() // 获取3个月前的日期
    }
  },
  created() {
    if(this.currentWeek) {
      this.getCurrentWeek()
    }
    if(this.startTime && this.endTime) {
      this.value = [this.startTime,this.endTime]
      this.start = this.startTime
      this.end = this.endTime
    }
  },
  watch: {
    startTime(newVal, oldVal) {
      if(newVal) {
        this.value = [this.startTime,this.endTime]
      }
    },
    showCalendar(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.calendarComponent && this.$refs.calendarComponent.update(); // 强制更新
        });
      }
    }
  },
  methods: {
    toShow() {
      this.showCalendar = true
    },
		// 获取3个月前的日期
    getThreeMonthsAgo() {
      const date = new Date()
      date.setMonth(date.getMonth() - 3) // 设置为3个月前
      return date
    },
    formatter(day) {
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();

      // 获取今天的日期
      const today = new Date();
      
      // 判断是否是同一天
      const isToday = day.date.getFullYear() === today.getFullYear() && 
			day.date.getMonth() === today.getMonth() && 
			day.date.getDate() === today.getDate();
      
      // 如果是今天，可以添加特殊样式或标记
      if (isToday) {
        return {
          ...day,
          className: 'is-today', // 添加自定义类名
					text: '今天'
          // text: `${month}/${date}`,
          // topInfo: '今天' // 可以在日期上方显示"今天"标记
        };
      }

      return day;
    },
		onSelect(date) {
      this.currentDate = date // 更新选中的日期
    },
		onConfirm() {
      this.changeTime(this.currentDate)
    },
    // 自定义日历单元格内容
    formatDate(timestamp) {
			if(!timestamp) return ''
			let date = new Date(timestamp)
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
		clearDate() {
      this.start = ''
      this.end = ''
      this.showCalendar = false
			this.date = ''
			this.$emit('changeTime',this.start,this.end)
    },
    changeTime(arr) {
			console.log(arr);
			
      if(!arr || arr.length == 0) {
        this.start = ''
        this.end = ''
      } else {
        this.start = arr[0].getTime()
        this.end = arr[1].getTime()
      }
			if(this.styleType == 2) {
				this.showCalendar = false;
      	this.date = `${this.formatDate(this.start)} 至 ${this.formatDate(this.end)}`;
			}
      this.$emit('changeTime',this.start,this.end)
    },
    getCurrentWeek() {
      let obj = getCurrentWeekStartTimeAndEndTime()
      this.value = [obj.startTime,obj.endTime]
      this.start = obj.startTime
      this.end = obj.endTime
			if(this.styleType == 2) {
				this.showCalendar = false;
      	this.date = `${this.formatDate(this.start)} 至 ${this.formatDate(this.end)}`;
			}
      this.$emit('changeTime',this.start,this.end)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-range-editor.el-input__inner {
  width: 237px;
  height: 28px;
  background: #FFFFFF;
  border-radius: 2px 2px 2px 2px;
  opacity: 1;
  border: 1px solid #E6E6E6;
}
/deep/ .el-range-separator {
  width: 24px !important;
}
.time2 {
  padding: 0 10px;
  height: 24px;
  background: #FFFFFF;
  border-radius: 17px 17px 17px 17px;
  border: 1px solid #F5F5F5;
	color: #666666;
  font-size: 14px;
  .prefix_img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}
.calendar-footer {
  display: flex;
  padding: 0 16px 10px 16px;
  gap: 12px;
  
  .van-button {
    flex: 1;
    height: 40px;
  }
}
.is-today {
	color: #0a89ff;
}
</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/datePicker.vue